import { ContractType } from './contract.interfaces';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { Contract } from '../contract.model';
import { isCamp } from '../../camp/lib/camp.util';
import { getScheduleInterval } from '../../_lib/schedule';
import { extractDateLabel } from '../../../util/date';
import { NonNullableFormBuilder } from '@angular/forms';

export const contractTypeLabels = {
  [ContractType.GeenContract]: $localize`No contract`,
  [ContractType.Monitor]: $localize`Monitor contract`,
  [ContractType.MonitorNietStudent]: $localize`Monitor contract (non-student)`,
  [ContractType.Studentenjob]: $localize`Student contract`,
  [ContractType.Bijklusser]: $localize`Side job contract`,
  [ContractType.Vrijwilliger]: $localize`Volunteer contract`,
} as const satisfies { [key in ContractType]: string };

export const contractTypeOptions = Object.entries(contractTypeLabels).map(
  ([key, value]) => ({ title: value, value: key as ContractType }),
);

@Pipe({
  name: 'extractContractPeriod',
  standalone: true,
})
export class ContractPeriodPipe implements PipeTransform {
  transform(contract: Contract): string {
    const rootTarget = contract.activity.rootTarget;
    const period =
      isCamp(rootTarget) && rootTarget.period
        ? `${rootTarget.period.label} ${rootTarget.period.week}`
        : null;
    return (
      period ?? extractDateLabel(getScheduleInterval(rootTarget.schedule).start)
    );
  }
}

export const createContractDataFormGroup = (fb?: NonNullableFormBuilder) => {
  fb ??= inject(NonNullableFormBuilder);

  return fb.group({
    type: fb.control(ContractType.Monitor),
    hourlyPay: fb.control(null as null | number),
  });
};
